import { contains } from 'ramda';

import {
    XMLFORM,
    XMLRESUME,
    XMHT,
    XMLTEST,
} from 'constants/documentTypes';

export const canPrint = (documentType) => contains(documentType, [XMLFORM, XMLRESUME, XMHT, XMLTEST]);
